import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function ScrollIndicator() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    let hasScrolled = false;
    let timer: ReturnType<typeof setTimeout>;
    const handleScroll = () => {
      hasScrolled = true;
      setShow(false);
    };
    const isAtBottom = () => {
      return window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50;
    };
    timer = setTimeout(() => {
      if (!hasScrolled && !isAtBottom()) {
        setShow(true);
      }
    }, 8000);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-96">
      {show && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 10
    }} transition={{
      duration: 0.5
    }} className="fixed bottom-8 right-6 z-30 pointer-events-none" data-id="element-97">
          <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="flex flex-col items-center gap-1 bg-white/10 backdrop-blur-sm rounded-full px-3 py-2.5" data-id="element-98">
            <ChevronDownIcon size={20} className="text-lime" data-id="element-99" />
            <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-lime" data-id="element-100">
              Scrollen
            </span>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}